import * as loadQueueHelper from '../../../js/document/load-queue'
import RecaptchaEngine from './recaptcha'

loadQueueHelper.add(function () {
  window.createRecaptchasOnDocument = RecaptchaEngine.createRecaptchasOnDocument
  RecaptchaEngine.injectRecaptchaScript('createRecaptchasOnDocument')
}, 3)
